export enum UserType{
    tenant = 'tenant',
    landlord = 'landlord',
    admin = 'admin',
    SuperAdmin = 'SuperAdmin'
}